import './CreateRequestWithdraw.scss';
import { InputSelect, InputText, InputNumber } from 'components';
import { Button, InputWraper, useForm } from 'modules';
import React from 'react';
import * as Yup from 'yup';
import { components } from 'react-select';
import { toast } from 'react-hot-toast';
import { useGetListAccountBanksQuery } from 'services';
import { useCreateRequestWithdrawMutation } from 'services';
import { useGetUserProfileQuery } from 'services';

const componentsElement = components as any;

const CustomOption = (props: any) => (
  <componentsElement.Option {...props}>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        minWidth: 1000,
      }}
    >
      <img src={props.data.logo} alt='' className='image-bank' />
      {props.data.label}
    </div>
  </componentsElement.Option>
);

const CustomSingleValue = (props: any) => (
  <componentsElement.SingleValue {...props}>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        minWidth: 500,
      }}
    >
      <img src={props.data.logo} alt='' className='image-bank' />
      {props.data.label}
    </div>
  </componentsElement.SingleValue>
);

const CustomControl = (props: any) => (
  <componentsElement.Control {...props}>
    <div style={{ padding: 5, width: '100%', height: '100%', display: 'flex' }}>
      {props.children}
    </div>
  </componentsElement.Control>
);

const CustomMenu = (props: any) => (
  <componentsElement.Menu {...props}>
    <div
      style={{
        borderRadius: 4,
        width: '100%',
        height: '100%',
        display: 'flex',
      }}
    >
      {props.children}
    </div>
  </componentsElement.Menu>
);

const CreateRequestWithdraw = () => {
  const { mutateAsync } = useCreateRequestWithdrawMutation();
  const { data: listBanks } = useGetListAccountBanksQuery();
  const { data } = useGetUserProfileQuery();

  const { handleSubmit, getInputProps, resetForm, setValues } = useForm({
    structure: [
      {
        name: 'amount',
        label: 'Số điểm',
        validate: Yup.string().required('Vui lòng nhập số điểm'),
        defaultValue: 0,
      },
      {
        name: 'fullName',
        label: 'Tên tài khoản',
        validate: Yup.string().required('Vui lòng nhập tên tài khoản'),
        defaultValue: data?.fullName,
        isDisabled: true,
      },
      {
        name: 'bankAccountId',
        label: 'Tài khoản ngân hàng',
        validate: Yup.string().required('Vui lòng chọn Ngân hàng'),
      },
    ],
    onSubmit: async (values) => {
      const normalizedValues = {
        bankAccountId: values.bankAccountId,
        amount: values.amount,
      };
      try {
        await mutateAsync(normalizedValues);
        toast.success('Tạo Yêu cầu rút điểm thành công', { duration: 1500 });
        resetForm();
      } catch (error) {
        console.log('error', error);
      }
    },
  });

  const getSecretBank = (value: string) => {
    if (value.length <= 10) {
      return value.slice(0, 2) + '****' + value.slice(-2);
    } else {
      return value.slice(0, 4) + '****' + value.slice(-4);
    }
  };

  return (
    <div className='create-request-withdraw'>
      <div className='row container-fluid-request-withdraw'>
        <h1>Tạo yêu cầu rút điểm</h1>
        <InputWraper
          className='col-lg-12'
          inputProps={getInputProps('amount')}
          component={InputNumber}
        />
        <InputWraper
          className='col-lg-12'
          inputProps={getInputProps('fullName')}
          component={InputText}
        />
        <InputWraper
          className='col-lg-12'
          inputProps={getInputProps('bankAccountId')}
          renderInput={(props) => (
            <InputSelect
              {...props}
              onChange={(e) => {
                setValues({ bankAccountId: e });
                props.onChange(e);
              }}
              options={listBanks?.data?.map((item) => ({
                label:
                  item.bank.shortName +
                  ' - ' +
                  item.bank.name +
                  ' - ' +
                  getSecretBank(item.accountNumber),
                value: item.id,
                logo: item.bank.logo,
              }))}
              components={{
                Menu: CustomMenu,
                Control: CustomControl,
                SingleValue: CustomSingleValue,
                Option: CustomOption,
              }}
            />
          )}
        />
      </div>

      <p className='text-danger'>
        * Chúng tôi không chịu trách nhiệm cho việc điền sai thông tin nhận tiền
        hoặc bị hack tài khoản
      </p>
      <div className='wrap-button-create-user'>
        <Button
          label='Gửi yêu cầu'
          type='submit'
          onClick={handleSubmit}
          buttonType='success'
        />
      </div>
    </div>
  );
};

export default CreateRequestWithdraw;
